import type { SettlementRecord, Worker } from "./types.js";
import { calculateWorkerPayable, settlementAdjustmentAmounts } from "./settlementAmounts.js";

type BankAccount = Pick<Worker, "bankCode" | "accountNumber" | "accountHolder">;

export const bankAccountReady = (worker?: BankAccount) => Boolean(
  worker?.bankCode.trim() && worker.accountNumber.replace(/[^0-9]/g, "") && worker.accountHolder.trim(),
);

/** 서버가 정산 당사자의 계좌를 확인한 결과를 우선한다. 운영 명부에는 비활성 작업자가 없다. */
export const settlementRecordBankReady = (record: SettlementRecord, worker?: BankAccount) =>
  record.workerBankAccountReady ?? bankAccountReady(worker);

export function settlementSelectionReady(selected: SettlementRecord[], workers: Worker[]) {
  const people = new Map(workers.map(worker => [worker.id, worker]));
  const grouped = new Map<string, SettlementRecord[]>();
  for (const record of selected) grouped.set(record.workerId, [...(grouped.get(record.workerId) ?? []), record]);
  return [...grouped].every(([workerId, records]) => calculateWorkerPayable(
    records.reduce((sum, record) => sum + record.grossAmount, 0),
    records.reduce((sum, record) => sum + settlementAdjustmentAmounts(record).deductionAmount, 0),
    records.reduce((sum, record) => sum + settlementAdjustmentAmounts(record).additionAmount, 0),
    records.reduce((sum, record) => sum + (record.manualAmount ?? 0), 0),
  ) <= 0 || records.every(record => settlementRecordBankReady(record, people.get(workerId))));
}
